import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
    MdDashboard,
    MdAccountTree,
    MdOutlineBusinessCenter,
    // MdOutlineAttachMoney,
    MdOutlineSwapHoriz,
    MdBarChart,
    MdPeople,
    MdLocationOn,
    MdChevronRight,
} from "react-icons/md";
import {
    RiGovernmentLine,
    RiMoneyDollarCircleLine,
    RiFunctionLine,
    RiStackLine,
    RiFlowChart,
} from "react-icons/ri";
import "./Sidebar.css";

/* ─── Nav config ─────────────────────────────────────────────── */
const NAV = [
    {
        section: "Overview",
        items: [
            { to: "/dashboard", icon: <MdDashboard />, label: "Dashboard" },
        ],
    },
    {
        section: "Charts of Accounts",
        items: [
            {
                label: "Charts of Accounts",
                icon: <MdAccountTree />,
                key: "charts",
                children: [
                    { to: "/administrative-units", icon: <RiGovernmentLine />, label: "Administrative Units" },
                    { to: "/economic-segment", icon: <RiMoneyDollarCircleLine />, label: "Economic Segment" },
                    { to: "/functional-segment", icon: <RiFunctionLine />, label: "Functional Segment" },
                    { to: "/programme-segment", icon: <RiStackLine />, label: "Programme Segment" },
                    { to: "/fund-segment", icon: <RiFlowChart />, label: "Fund Segment" },
                    { to: "/geo-locations", icon: <MdLocationOn />, label: "Geo Locations" },
                ],
            },
        ],
    },
    {
        section: "Finance",
        items: [
            { to: "/budgets", icon: <RiGovernmentLine />, label: "Budgets" },
            { to: "/budget-lines", icon: <MdOutlineBusinessCenter />, label: "Budget Lines" },
            { to: "/transactions", icon: <MdOutlineSwapHoriz />, label: "Transactions" },
        ],
    },
    {
        section: "Insights",
        items: [
            { to: "/reports", icon: <MdBarChart />, label: "Reports" },
        ],
    },
    {
        section: "Admin",
        items: [
            { to: "/admin/users", icon: <MdPeople />, label: "Users" },
        ],
    },
];

/* ─── Single nav item ────────────────────────────────────────── */
const MenuItem = ({ item, onNavigate }) => {
    const [open, setOpen] = useState(false);

    if (item.children) {
        return (
            <>
                <div
                    className={`sb-item ${open ? "sub-open" : ""}`}
                    onClick={() => setOpen(p => !p)}
                >
                    <span className="sb-icon">{item.icon}</span>
                    <span className="sb-label">{item.label}</span>
                    <span className="sb-chevron"><MdChevronRight /></span>
                </div>

                <div className={`sb-submenu ${open ? "open" : ""}`}>
                    {item.children.map(child => (
                        <NavLink
                            key={child.to}
                            to={child.to}
                            className={({ isActive }) => `sb-sub-item${isActive ? " active" : ""}`}
                            onClick={onNavigate}
                        >
                            <span className="sb-sub-dot" />
                            <span className="sb-sub-label">{child.label}</span>
                        </NavLink>
                    ))}
                </div>
            </>
        );
    }

    return (
        <NavLink
            to={item.to}
            className={({ isActive }) => `sb-item${isActive ? " active" : ""}`}
            onClick={onNavigate}
        >
            <span className="sb-icon">{item.icon}</span>
            <span className="sb-label">{item.label}</span>
        </NavLink>
    );
};

/* ─── Sidebar ────────────────────────────────────────────────── */
const Sidebar = () => (
    <div className="sidebar">

        {/* Brand */}
        <div className="sb-brand">
            <span className="sb-brand-icon">🇳🇬</span>
            <div className="sb-brand-text">
                <span className="sb-brand-title">Budget Portal</span>
                <span className="sb-brand-sub">Federal Republic of Nigeria</span>
            </div>
        </div>

        {/* Nav */}
        <nav className="sb-nav">
            {NAV.map(({ section, items }) => (
                <div key={section}>
                    <div className="sb-section-label">{section}</div>
                    {items.map(item => (
                        <MenuItem key={item.label || item.to} item={item} />
                    ))}
                    <div className="sb-divider" />
                </div>
            ))}
        </nav>

        {/* Footer hint */}
        <div className="sb-footer">
            <div className="sb-footer-hint">
                <span className="sb-footer-icon">◀▶</span>
                <span className="sb-footer-text">Hover sidebar to expand</span>
            </div>
        </div>
    </div>
);

export default Sidebar;